import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { useScheduleData, UseScheduleDataReturn } from "../scheduleData";

interface ServiceTypeFilterProps {
  selectedServiceTypes: string[];
  onServiceTypeChange: (serviceType: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
  isDarkMode?: boolean;
}

export function ServiceTypeFilter({
  selectedServiceTypes,
  onServiceTypeChange,
  onSelectAll,
  isDarkMode = false,
}: ServiceTypeFilterProps) {
  const s = useScheduleData();
  const { serviceTypesInfo = [] } = (s || {}) as Partial<UseScheduleDataReturn>;

  const visibleServices = serviceTypesInfo?.filter(
    (s) => s?.serviceType !== 1 && s?.serviceType !== 3,
  ) || [];

  const isAllSelected =
    visibleServices.length > 0 &&
    visibleServices.every((service) => {
      const idOrName = service._id || service.name;
      return selectedServiceTypes.includes(idOrName);
    });

  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Service Type
      </h4>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="select-all-service-types"
            checked={isAllSelected}
            onCheckedChange={onSelectAll}
          />
          <label
            htmlFor="select-all-service-types"
            className={`text-sm cursor-pointer transition-colors duration-300 ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Select All
          </label>
        </div>
        <hr
          className={`transition-colors duration-300 ${
            isDarkMode ? "border-gray-600" : "border-gray-200"
          }`}
        />
        {visibleServices.map((service) => {
          const serviceId = service._id || service.name;
          return (
            <div key={serviceId} className="flex items-center space-x-2">
              <Checkbox
                id={`service-${serviceId}`}
                checked={selectedServiceTypes.includes(serviceId)}
                onCheckedChange={(checked) =>
                  onServiceTypeChange(serviceId, !!checked)
                }
              />
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: service.serviceColor }}
              />
              <label
                htmlFor={`service-${serviceId}`}
                className={`text-sm cursor-pointer transition-colors duration-300 ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                {service.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
